import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

export const transformApiDrivenInput = (v: GenericObject, property: string, language: string) => {
  // The property may be optional (e.g. Media)
  if (v[property]) {
    // Sometimes get a phantom empty string (in particular, when adding a response,
    // then removing it and adding a new response)

    // @ts-ignore responses definitely exist
    if (v[property][language][0] === '') {
      // @ts-ignore responses definitely exist
      v[property][language] = v[property][language].slice(1);
    }

    // If guard protects against edge case that popped up in UAT
    // @ts-ignore responses definitely exist
    if (Array.isArray(v[property][language])) {
      // @ts-ignore responses definitely exist
      v[property][language] = v[property][language].join(',');
    }
  }

  return v;
};
